var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"id":"tableDataTabs","columns":_vm.columns,"dataSource":_vm.tableData,"pagination":false,"bordered":""}})}
var staticRenderFns = []

export { render, staticRenderFns }